import { useState, useEffect } from 'react';
import { collection, getDocs } from "firebase/firestore";
import { db } from '../../../firebase/firestore';

export const useMaterials = () => {
  const [availableTrainings, setAvailableTrainings] = useState([]);
  const [availableCourses, setAvailableCourses] = useState([]);
  const [trainingsMap, setTrainingsMap] = useState({});
  const [coursesMap, setCoursesMap] = useState({});
  const [expandedMaterials, setExpandedMaterials] = useState({});

  const loadTrainingsAndCourses = async () => {
    try {
      const trainingsSnap = await getDocs(collection(db, "trainings"));
      const trainingsItems = trainingsSnap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter(t => t.status !== "draft");
      
      const coursesSnap = await getDocs(collection(db, "courses"));
      const coursesItems = coursesSnap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter(c => c.status !== "draft");
      
      setAvailableTrainings(trainingsItems);
      setAvailableCourses(coursesItems);
      
      const trainingsMapping = {};
      trainingsItems.forEach(t => { trainingsMapping[t.id] = t.title; });
      setTrainingsMap(trainingsMapping);
      
      const coursesMapping = {};
      coursesItems.forEach(c => { coursesMapping[c.id] = c.title; });
      setCoursesMap(coursesMapping);
      
    } catch (error) {
      console.error("Error loading trainings and courses:", error);
    }
  };

  const toggleMaterialsExpand = (userId) => {
    setExpandedMaterials(prev => ({
      ...prev,
      [userId]: !prev[userId]
    }));
  };

  const getTrainingAccess = (trainingId, trainingsAccess) => {
    return trainingsAccess?.find(a => a.id === trainingId) || null;
  };

  const getCourseAccess = (courseId, coursesAccess) => {
    return coursesAccess?.find(a => a.id === courseId) || null;
  };

  const getTrainingTitle = (trainingId) => {
    return trainingsMap[trainingId] || trainingId.substring(0, 8) + '...';
  };

  const getCourseTitle = (courseId) => {
    return coursesMap[courseId] || courseId.substring(0, 8) + '...';
  };

  useEffect(() => {
    loadTrainingsAndCourses();
  }, []);

  return {
    availableTrainings,
    availableCourses,
    trainingsMap,
    coursesMap,
    expandedMaterials,
    toggleMaterialsExpand,
    getTrainingAccess,
    getCourseAccess,
    getTrainingTitle,
    getCourseTitle,
    loadTrainingsAndCourses
  };
};